import {Card} from 'platform/components';
import {Align, Box, Heading, Hide, Text, VStack} from 'platform/foundation';

import {Trans} from 'react-i18next';

import {isEmpty, isNil, last} from 'ramda';

import {isNotNilOrEmpty, suffixTestId, TestIdProps} from 'shared/web';

import {Alert} from '../../../../components/Alert/Alert';
import {AvoidBreakInside} from '../../../../components/AvoidBreakInside/AvoidBreakInside';
import i18n from '../../../../i18n/i18n';
import {MarketType} from '../../../../types/MarketType';
import {VehicleType} from '../../../../types/VehicleType';
import {useIsPrintForced} from '../../hooks/useIsPrintForced';
import {ColorChart} from './components/ColorChart';

interface StatisticsCardColorProps extends TestIdProps {
  vehicle: VehicleType;
  market?: MarketType;
}

export function StatisticsCardColor(props: StatisticsCardColorProps) {
  const {isPrint} = useIsPrintForced();

  const data =
    props.market?.colorChart?.statisticsAggregated
      ?.map((item) => ({
        name: last(item.levels)?.value,
        count: item.statistics.reduce((acc, curr) => acc + curr.amount, 0),
      }))
      ?.filter((item) => isNotNilOrEmpty(item.name) && item.name.substring(0, 9) !== 'CARSTYLE_') ??
    [];

  return (
    <Hide when={isNil(props.market?.colorChart) || isEmpty(data)}>
      <AvoidBreakInside>
        <Card variant={isPrint ? 'inlineWhite' : undefined} data-testid={props['data-testid']}>
          <Box padding={2}>
            <VStack spacing={6}>
              <Align center>
                <Heading size={3}>{i18n.t('entity.overviewStatistics.labels.colorTitle')}</Heading>
              </Align>
              <Text
                align="center"
                size="small"
                color="secondary"
                data-testid={suffixTestId('colorDescription', props)}
              >
                <Trans
                  i18nKey="entity.overviewStatistics.labels.colorDescription"
                  components={{bold: <Text key="bold" alternative inline size="small" />}}
                />
              </Text>

              <ColorChart
                vehicle={props.vehicle}
                colorChartData={data}
                data-testid={suffixTestId('colorChart', props)}
              />

              <Alert icon="action/info_outline" data-testid={suffixTestId('colorAlert', props)}>
                {i18n.t('entity.overviewStatistics.labels.colorAlert')}
              </Alert>
            </VStack>
          </Box>
        </Card>
      </AvoidBreakInside>
    </Hide>
  );
}
